import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ContactForm from "./ContactForm";
import {
    AiFillGithub,
    AiOutlineTwitter,
    AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import "./Contact.css";

function Contact() {
    return (
        <Container fluid className="contact-section">
            <Particle />
            <Container>
                <Row className="justify-content-center" style={{ alignItems: "center" }}>
                    <Col md={6} className="contact-text-section">
                        <h1>Do you have any <span className="purple">questions?</span></h1>
                        <p>
                            We're always there to help you, alternatively you can contact us
                            through our social media below
                        </p>
                        <ul className="contact-social-icons">
                            <li>
                                <a
                                    href="https://github.com/anupamsinha18"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <AiFillGithub />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://x.com/18anupamSinha"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <AiOutlineTwitter />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.linkedin.com/in/anupam-sinha-9851961a9/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <FaLinkedinIn />
                                </a>
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/18anupam_sinha/"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <AiFillInstagram />
                                </a>
                            </li>
                        </ul>
                    </Col>
                    <Col md={6}>
                        <ContactForm />
                    </Col>
                </Row>
            </Container>
        </Container>
    );
}

export default Contact;
